/* istanbul ignore file */
import { MenuItem } from './Menu.tsx';
import { IconArrowLeft } from '@tabler/icons-react';

export const MenuItemsAdmin: MenuItem[] = [
    {
        label: 'DASHBOARD',
        icon: 'stats-up',
        url: '/admin/dashboard',
    },
    {
        label: 'LEGACY',
        icon: 'layout-placeholder',
        legacyUrl: '/admin/customers/instalaciones',
    },
    {
        label: 'CUENTAS',
        icon: 'book',
        url: '/admin/cuentas',
    },
    {
        label: 'SUSCRIPCIONES',
        icon: 'reload',
        url: '/admin/suscripciones',
    },
    {
        label: 'BlOQUEADAS',
        icon: 'na',
        url: '/admin/bloqueadas',
    },
    {
        label: 'MAILS',
        icon: 'email',
        url: '/admin/mails',
    },
    {
        label: 'CONTRATACIONES',
        icon: 'shift-right-alt',
        url: '/admin/contrataciones',
    },
    {
        label: 'USUARIOS',
        icon: 'user',
        url: '/admin/usuarios',
    },
    {
        label: 'MIGRACIONES',
        icon: 'bar-chart-alt',
        url: '/admin/migraciones',
    },
    {
        label: 'TRIALS',
        icon: 'timer',
        url: '/admin/trials',
    },
    {
        label: 'COBRANZAS',
        icon: 'money',
        children: [
            {
                label: 'COBRANZAS',
                icon: 'money',
                url: '/admin/cobranzas',
            },
            {
                label: 'TRANSFERENCIAS',
                icon: 'arrows-horizontal',
                url: '/admin/transferencias',
            },
            {
                label: 'DUNNING',
                icon: 'calendar',
                url: '/admin/cobranzas/dunning',
            },
            {
                label: 'PLANES',
                icon: 'bookmark-alt',
                url: '/admin/planes',
            },
            {
                label: 'REPORTES ZR',
                icon: 'align-left',
                url: '/admin/cobranzas/reportes_zenrise',
            },
            {
                label: 'INVOICES',
                icon: 'agenda',
                url: '/admin/cobranzas/invoices',
            },
        ],
    },
    {
        label: 'AUDITLOGS',
        icon: 'book',
        url: '/admin/auditlogs',
    },
    {
        label: 'FACTURACION',
        icon: 'credit-card',
        children: [
            {
                label: 'FACTURAS',
                icon: 'view-list',
                url: '/admin/facturacion/facturas',
            },
            {
                label: 'FACTURAR AFIP',
                icon: 'arrows-horizontal',
                url: '/admin/facturacion/facturar',
            },
            {
                label: 'PLANNING',
                icon: 'calendar',
                url: '/admin/facturacion/planning',
            },
            {
                label: 'APILOGS',
                icon: 'calendar',
                url: '/admin/facturacion/tusfacturasapilog',
            },
            {
                label: 'WEBHOOKS',
                icon: 'calendar',
                url: '/admin/facturacion/tusfacturaswebhooks',
            },
        ],
    },
    {
        label: 'VARIOS',
        icon: 'money',
        children: [
            {
                label: 'ADMIN',
                icon: 'headphone-alt',
                url: '/admin',
            },
            {
                label: 'EVENTS',
                icon: 'headphone-alt',
                url: '/admin/events',
            },
            {
                label: 'DIARIOS',
                icon: 'money', //TODO: poner un ícono
                url: '/admin/procesosdiarios',
            },
        ],
    },
    {
        label: 'SALIR',
        icon: <IconArrowLeft />,
        url: '/logout',
    },
];
